import { events as viewEvent } from './view-event';
// import {events as actionEvent} from './action-event';
// import {events as resultEvent} from './result-event';

export const events = ({ tracker, condition }) => {
  const viewEventSet = viewEvent({ tracker, condition });
  // const actionEventSet = actionEvent({tracker, condition})
  // const resultEventSet = resultEvent({tracker, condition})
  return {
    ...viewEventSet,
    // ...actionEventSet,
    // ...resultEventSet
  };
};
